import request from "../../../../utils/api";

const url = "segments";

export const getSegments = params => request(url, { params });
export const postSegment = params => request(url, { method: 'post', params });
export const putSegment = params => request(`${url}/${params.id}`, { method: 'put', params: params.segment });
export const deleteSegment = body => request(`${url}/${body}`, { method: 'delete' });